import React from "react";
import PropTypes from "prop-types";
import RadioButton from "../components/RadioButton";
import "./SingleChoice.scss";

const SingleChoice = ({
  question,
  fieldName,
  value,
  error,
  setFieldValue,
  setFieldTouched,
}) => {
  const handleChange = e => {
    setFieldValue(fieldName, e.target.value);
    setFieldTouched(fieldName, true);
  };

  return (
    <div className="single-choice">
      <div className="single-choice__header">
        {question.question && (
          <h2 className="single-choice__title">
            {question.question}
            {question.required && (
              <span className="single-choice__required">*</span>
            )}
          </h2>
        )}
        <p className="single-choice__subtitle">{question.helper_text}</p>
      </div>

      <div className="single-choice__options">
        {question.options &&
          question.options.map((option, index) => (
            <RadioButton
              key={`${fieldName}-${index}`}
              id={`${fieldName}-${index}`}
              name={fieldName}
              value={option}
              label={option}
              checked={value === option}
              onChange={handleChange}
            />
          ))}
      </div>

      {error && <div className="single-choice__error">{error}</div>}
    </div>
  );
};

SingleChoice.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

SingleChoice.defaultProps = {
  value: "",
  error: null,
};

export default SingleChoice;
